import { Controller, useFormContext } from "react-hook-form";
import { Switch } from "rizzui";

export interface DirectoryPageProps {
  isSuperAdmin?: boolean;
  moduleTopName: string;
  moduleBottomName: string;
  moduleDynamicLayoutName: string;
  moduleOtpVerificationName: string;
}

export default function DirectoryPage({
  isSuperAdmin,
  moduleTopName,
  moduleBottomName,
  moduleDynamicLayoutName,
  moduleOtpVerificationName,
}: DirectoryPageProps) {
  const { control } = useFormContext();

  return (
    <div className="grid grid-cols-1 gap-2 w-full">
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">Directory Module</h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <Controller
            control={control}
            name={`${moduleTopName}.enable`}
            render={({ field, fieldState, formState }) => (
              <Switch
                label="Enable"
                size="lg"
                className=" w-auto"
                {...field}
                checked={field.value || false}
                error={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">Auto Add New Project</h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <Controller
            control={control}
            name={`${moduleBottomName}.enable`}
            render={({ field, fieldState, formState }) => (
              <Switch
                label="Enable"
                size="lg"
                className=" w-auto"
                {...field}
                checked={field.value || false}
                error={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">Dynamic Layout</h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <Controller
            control={control}
            name={`${moduleDynamicLayoutName}.enable`}
            render={({ field, fieldState, formState }) => (
              <Switch
                label="Enable"
                size="lg"
                className=" w-auto"
                {...field}
                checked={field.value || false}
                error={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">
          Enable OTP Verification for Lead Forms
        </h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <Controller
            control={control}
            name={`${moduleOtpVerificationName}.enable`}
            render={({ field, fieldState, formState }) => (
              <Switch
                label="Enable"
                size="lg"
                className=" w-auto"
                {...field}
                checked={field.value || false}
                error={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
    </div>
  );
}
